module.exports = __webpack_public_path__ + "static/media/rounded1.0b781094.png";